<template>
    <div class="form">
        <el-form style="margin:20px;width:60%;min-width:600px;" label-width="130px">
            <el-form-item class='edit-form' label="销售下单号">
                <span>{{Form.OrderCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="销售下单审核状态">
                <span>{{Form.OrderStatusName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="代理商">
                <span>{{Form.AgentName}} {{Form.AreaName}} {{Form.AgentTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="销售下单时间">
                <span>{{Form.OrderTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="销售下单人">
                <span>{{Form.SaleEmployeeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="要求发货时间">
                <el-date-picker v-model="AddForm.RequireSendDate" type="date" placeholder="选择日期" style="  margin-left: 25px;">
                </el-date-picker>
            </el-form-item>
            <el-form-item class='edit-form' label="发货情况">
                <el-radio-group style="  margin-left: 25px;" v-model="SendGood">
                    <el-radio-button label="全部发货" value="1"></el-radio-button>
                    <el-radio-button label="部分发货" value="1"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item class='edit-form' label="商品" v-show="myProduct!=''">
                <el-table :data="myProduct" border style="width: 80%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="订单数">
                    </el-table-column>
                    <el-table-column prop="UnSendNum" label="未通知数">
                    </el-table-column>
                    <el-table-column prop="SendNum" label="通知数">
                        <template scope="scope">
                            <!--  <el-input v-model="scope.row.SendNum" :disabled="Isabled"></el-input>-->
                            <el-input-number style="width: 100px;margin-top: 5px" size="small" :min="0" :max="scope.row.UnSendNum" v-model="scope.row.SendNum" :disabled="Isabled"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="赠品" v-show="myGifts!=''">
                <el-table :data="myGifts" border style="width: 80%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="订单数">
                    </el-table-column>
                    <el-table-column prop="UnSendNum" label="未通知数">
                    </el-table-column>
                    <el-table-column prop="SendNum" label="通知数">
                        <template scope="scope">
                            <!--  <el-input v-model="scope.row.SendNum" :disabled="Isabled"></el-input>-->
                            <el-input-number style="width: 100px;margin-top: 5px" size="small" :min="0" :max="scope.row.UnSendNum" v-model="scope.row.SendNum" :disabled="Isabled"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="收货地址">
                <span>{{Form.AgentConsignee}}</span>
                <el-button class="btn" @click="AddressShow">修改</el-button>
            </el-form-item>
            <el-form-item class='edit-form' label="收货人及联系方式">
                <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="寄送方式">
                <span>{{Form.SendModeName}}</span>
                <el-button class="btn" @click="getCommonList(8)">修改</el-button>
            </el-form-item>
            <el-form-item class='edit-form' label="支付方式">
                <span>{{Form.PayModeName}}</span>
                <el-button class="btn" @click="getCommonList(9)">修改</el-button>
            </el-form-item>
            <el-form-item class='edit-form' label="销售下单备注">
                <span>{{Form.OrderRemark}}</span>
            </el-form-item>
        </el-form>
        <el-row>
            <el-col :span="24" style='display:flex;justify-content:center;margin-bottom: 25px'>
                <el-button type="primary" @click="createSure">确定</el-button>
            </el-col>
        </el-row>

        <el-dialog title="寄送方式" v-model='dialog.send' size="tiny">
            <el-radio-group v-model="SendMode">
                <el-radio v-for="item in SendList" :label="item.Id">{{item.ParmName}}</el-radio>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="SurePaySend(1)">确认修改</el-button>
            </span>
        </el-dialog>
        <el-dialog title="支付方式" v-model='dialog.pay' size="tiny">
            <el-radio-group v-model="PayMode">
                <el-radio v-for="item in PayList" :label="item.Id">{{item.ParmName}}</el-radio>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="SurePaySend(2)">确认修改</el-button>
            </span>
        </el-dialog>
        <el-dialog title="选择收货地址" v-model="dialog.addAddressVisible">
            <el-row>
                <el-table :data="AddressList" border style="width: 100%" @row-click="myRow">
                    <el-table-column prop="Address" label="收货地址">
                    </el-table-column>
                    <el-table-column prop="Consignee" label="收货人" width="180">
                    </el-table-column>
                    <el-table-column prop="ConsigneeTel" label="联系方式">
                    </el-table-column>
                    <el-table-column prop="IsDefault" label="是否默认">
                        <!--      <tempate scope="scope">
                                              <el-button >{{scope.row.IsDefault}}</el-button>
                                          </tempate>-->
                        <template scope="scope">
                            <el-button v-if="scope.row.IsDefault" type="success">当前默认</el-button>
                            <el-button v-else type="info" @click="setDefaultAddress(scope.$index, scope.row)">设为默认
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <el-form :inline="true" class="demo-form-inline" style="margin-top: 15px">
                <el-form-item>
                    <el-select placeholder="选择省" style="width:130px" @change="Province" v-model="Address.ConsigneeProvince">
                        <el-option v-for="item in ProvinceList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select placeholder="选择市" style="width:130px" @change="City" v-model="Address.ConsigneeCity">
                        <el-option v-for="item in CityList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select placeholder="选择区" style="width:130px" v-model="Address.ConsigneeArea">
                        <el-option v-for="item in AreaList" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入详细地址" style="width:450px" v-model="Address.ConsigneeAdress"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入联系人" style="width:200px" v-model="Address.Consignee"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入联系方式" style="width:200px" v-model="Address.ConsigneeTel"></el-input>
                </el-form-item>
                <el-form-item label="设为默认地址">
                    <el-switch on-text="" off-text="" v-model="Address.IsDefault"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addAddress">确认添加</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import NProgress from 'nprogress';
import {
    CreateSendGoodsByOrderId, ERP_SendGoodsAdd, GetERP_SendGoodsById, ERP_SendGoodsUpdate, LoadDataForSendGoodsEdit
} from '@api/orderApi.js';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import $http from '$http';

module.exports = {
    data() {
        return {
            AddAddress: false,
            dialog: {
                send: false,
                pay: false,
                addAddressVisible: false,
            },
            sysSid: "",
            sysSession: "",
            Form: {},
            AddressList: [],
            Pay: {},
            Send: {},
            PayList: [],
            SendList: [],
            ProvinceList: [],
            CityList: [],
            AreaList: [],
            sendAddress: {},
            SendGood: "",
            Isabled: false,
            Address: {
                "AgentId": "",
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeProvince": "",
                "ConsigneeCity": "",
                "ConsigneeArea": "",
                "ConsigneeAdress": "",
                "IsDefault": true
            },
            SendMode: "",
            PayMode: "",
            AddForm: {
                "AgentId": "",
                "OrderId": "",
                "RequireSendDate": "",
                "AgentConsigneeId": "",
                "SendMode": "",
                "PayMode": "",
                "DeliveryStatus": "",
                "ListGoods": [],
            },
            myProduct: [],
            myGifts: [],
        }
    },
    methods: {
        setDefaultAddress(index, item) {
            let Params = { Sid: this.sysSid, Session: this.sysSession, Id: item.Id, AgentId: this.Form.AgentId }
            ConsigneeSetDefault(Params).then(res => {
                util.doResult(this, res,
                    () => {
                        GetAgentConsigneeList(Params).then(res => {
                            util.doResult(this, res,
                                () => {
                                    this.dialog.addAddressVisible = false;
                                    this.$notify({
                                        title: '成功',
                                        message: "设置默认地址成功",
                                        type: 'success'
                                    });

                                }
                            );
                        })

                    }
                );
            })

        },
        SurePaySend(type) {

            if (type == 1) {
                this.dialog.send = false;
                this.AddForm.SendMode = this.Send.Id;
                this.Form.SendModeName = this.Send.ParmName;
                this.SendModel = "";

            } else {
                this.dialog.pay = false;
                this.AddForm.PayMode = this.Pay.Id;
                this.Form.PayModeName = this.Pay.ParmName;
                this.PayMode = ""
            }
        },
        createSure() {
            this.AddForm.ListGoods = [];
            this.AddForm.GiftsList = [];
            this.AddForm.AgentConsigneeId = this.Form.AgentConsigneeId
            for (var i = 0; i < this.myProduct.length; i++) {
                var a = {};
                a.ProId = this.myProduct[i].ProId;
                a.ProNum = this.myProduct[i].SendNum;
                this.AddForm.ListGoods.push(a);
            }
            for (var i = 0; i < this.myGifts.length; i++) {
                var a = {};
                a.ProId = this.myGifts[i].ProId;
                a.ProNum = this.myGifts[i].SendNum;
                this.AddForm.GiftsList.push(a);
            }
            if (this.$route.query.update == 'true') {
                this.AddForm.SendId = this.$route.query.Id;

                ERP_SendGoodsUpdate(this.AddForm).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: '更新发货单成功',
                            type: 'success'
                        });
                        util.redirect(this, '/SendGoods/SendGoodsForBus', false);
                    });
                });
            }
            else {
                ERP_SendGoodsAdd(this.AddForm).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: '生成发货单成功',
                            type: 'success'
                        });
                        util.redirect(this, '/SendGoods/SendGoodsForBus', false);
                    });
                });
            }
        },
        myRow(val) {
            this.Form.AgentConsignee = val.Address
            this.Form.Consignee = val.Consignee;
            this.Form.ConsigneeTel = val.ConsigneeTel;
            this.Form.AgentConsigneeId = val.Id;
            this.dialog.addAddressVisible = false;

        },
        Province() {
            this.Address.ConsigneeCity = "";
            this.Address.ConsigneeArea = "";
            if (this.Address.ConsigneeProvince != "") {
                let Params = { Sid: this.sysSid, Session: this.sysSession, ProvinceId: this.Address.ConsigneeProvince };
                GetCitys(Params).then(res => {
                    util.doResult(this, res, () => {
                        this.CityList = res.data.Data;
                    });
                })
            }
        },//监听省获取市
        City() {
            this.Address.ConsigneeAdress = "";
            if (this.Address.ConsigneeCity != "") {
                let Params = { Sid: this.sysSid, Session: this.sysSession, CityId: this.Address.ConsigneeCity };
                GetAreas(Params).then(res => {
                    util.doResult(this, res, () => {
                        this.AreaList = res.data.Data;
                    });
                })
            }
        },//监听市获取区
        GetProvinces() {
            let Params = { Sid: this.sysSid, Session: this.sysSession }
            GetProvinces(Params).then(res => {
                util.doResult(this, res, () => {
                    this.ProvinceList = res.data.Data;
                });
            })
        },//获取省份
        addAddress() {
            this.Address.AgentId = this.Form.AgentId;
            Consignee_Add(this.Address).then(res => {
                util.doResult(this, res, () => {
                    this.sendAddress = res.data.Data;
                    this.getAddressList();
                    this.dialog.addAddressVisible = false;
                    this.AddAddress = true;
                });
            });
        },
        AddressShow() {
            this.getAddressList();
            this.dialog.addAddressVisible = true;
            this.GetProvinces();
        },
        getAddressList() {
            let param = { Sid: this.sysSid, Session: this.sysSession, AgentId: this.Form.AgentId }
            GetAgentConsigneeList(param).then(res => {
                util.doResult(this, res, () => {
                    this.AddressList = res.data.Data;
                    if (this.AddAddress) {
                        this.sendAddress = this.AddressList[this.AddressList.length - 1];
                        this.Form.AgentConsignee = this.sendAddress.Address
                        this.Form.Consignee = this.sendAddress.Consignee;
                        this.Form.ConsigneeTel = this.sendAddress.ConsigneeTel;
                        this.Form.AgentConsigneeId = this.sendAddress.Id;
                        this.AddAddress = false;
                    }
                });
            });
        },
        getCommonList(type) {
            let param = { Sid: this.sysSid, Session: this.sysSession, ParmType: type }
            GetParmConfig(param).then(res => {
                util.doResult(this, res, () => {
                    if (type == 8) {
                        this.SendList = res.data.Data;
                        this.dialog.send = true;
                    } else {
                        this.PayList = res.data.Data;
                        this.dialog.pay = true;
                    }
                });
            });
        },
    },
    created: function () {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.sysSid = user.Sid || '';
            this.sysSession = user.Session || '';
        }
        this.myProduct = [];

        if (this.$route.query.update == 'true') {
            let params = { Sid: this.sysSid, Session: this.sysSession, Id: this.$route.query.Id }
            LoadDataForSendGoodsEdit(params).then(res => {
                util.doResult(this, res, () => {
                    this.Form = res.data.Data;
                    this.AddForm.SendMode = this.Form.SendMode;
                    this.AddForm.PayMode = this.Form.PayMode;
                    this.AddForm.OrderId = this.Form.OrderId;
                    this.AddForm.AgentId = this.Form.AgentId;
                    this.AddForm.RequireSendDate = this.Form.RequireSendDate;
                    this.Form.OrderTime = this.Form.SendTime;
                    this.Form.OrderStatusName = this.Form.SendStatusName;
                    this.SendGood = this.Form.CurrentSendStatus;
                    if (this.Form.ListGoods.length > 0) {
                        for (var i = 0; i < this.Form.ListGoods.length; i++) {
                            var a = {};
                            a.ProId = this.Form.ListGoods[i].ProductId;
                            a.ProName = this.Form.ListGoods[i].ProName;
                            a.ProductNum = this.Form.ListGoods[i].ProductNum;
                            a.UnSendNum = this.Form.ListGoods[i].UnSendNum;
                            a.SendNum = this.Form.ListGoods[i].SendNum;
                            this.myProduct.push(a);
                        }
                    }
                    if (this.Form.GiftGoods.length > 0) {
                        for (var i = 0; i < this.Form.GiftGoods.length; i++) {
                            var a = {};
                            a.ProId = this.Form.GiftGoods[i].ProductId;
                            a.ProName = this.Form.GiftGoods[i].ProName;
                            a.ProductNum = this.Form.GiftGoods[i].ProductNum;
                            a.UnSendNum = this.Form.GiftGoods[i].UnSendNum;
                            a.SendNum = this.Form.GiftGoods[i].SendNum;
                            this.myGifts.push(a);
                        }
                    }
                    /*   for(var i=0;i<this.myProduct.length;i++){
                     if()
                     }*/

                });
            });

        } else {
            let param = { Sid: this.sysSid, Session: this.sysSession, OrderId: this.$route.query.Id }
            CreateSendGoodsByOrderId(param).then(res => {
                util.doResult(this, res, () => {
                    this.Form = res.data.Data;
                    this.AddForm.SendMode = this.Form.SendMode;
                    this.AddForm.PayMode = this.Form.PayMode;
                    this.AddForm.OrderId = this.Form.OrderId;
                    this.AddForm.AgentId = this.Form.AgentId;
                    if (this.Form.ListGoods.length > 0) {
                        for (var i = 0; i < this.Form.ListGoods.length; i++) {
                            var a = {};
                            a.ProId = this.Form.ListGoods[i].ProductId;
                            a.ProName = this.Form.ListGoods[i].ProName;
                            a.ProductNum = this.Form.ListGoods[i].ProductNum;
                            a.UnSendNum = this.Form.ListGoods[i].UnSendNum;
                            a.SendNum = "";
                            this.myProduct.push(a);

                        }
                    }
                    if (this.Form.GiftGoods.length > 0) {
                        for (var i = 0; i < this.Form.GiftGoods.length; i++) {
                            var a = {};
                            a.ProId = this.Form.GiftGoods[i].ProductId;
                            a.ProName = this.Form.GiftGoods[i].ProName;
                            a.ProductNum = this.Form.GiftGoods[i].ProductNum;
                            a.UnSendNum = this.Form.GiftGoods[i].UnSendNum;
                            a.SendNum = "";
                            this.myGifts.push(a);
                        }
                    }
                });
            });
        }
    },
    watch: {
        SendGood: function () {

            if (this.SendGood == '全部发货') {
                this.Isabled = true;
                for (var i = 0; i < this.myProduct.length; i++) {
                    this.myProduct[i].SendNum = this.myProduct[i].ProductNum
                }
                for (var i = 0; i < this.myGifts.length; i++) {
                    this.myGifts[i].SendNum = this.myGifts[i].ProductNum
                }
            } else {
                this.Isabled = false;
            }
        },
        SendMode: function () {
            for (var i = 0; i < this.SendList.length; i++) {
                if (this.SendList[i].Id == this.SendMode) {
                    this.Send.ParmName = this.SendList[i].ParmName;
                    this.Send.Id = this.SendMode;
                }
            }
        },
        PayMode: function () {
            for (var i = 0; i < this.PayList.length; i++) {
                if (this.PayList[i].Id == this.PayMode) {
                    this.Pay.ParmName = this.PayList[i].ParmName;
                    this.Pay.Id = this.PayMode;
                }
            }

        }
    }
}
</script>
<style scoped>
.btn {
    margin-left: 20px;
}

span {
    margin-left: 25px;
}
</style>


// WEBPACK FOOTER //
// CreateSkipOrder.vue?1ac369de